// extracted by mini-css-extract-plugin
export default {"content":"Detail_content__Uau7x","wrapperContent":"Detail_wrapperContent__vWEhi","stickyShadowFooter":"Detail_stickyShadowFooter__yxGd3"};